import { render, staticRenderFns } from "./Lvl.vue?vue&type=template&id=887c479e&scoped=true&"
import script from "./Lvl.vue?vue&type=script&lang=ts&"
export * from "./Lvl.vue?vue&type=script&lang=ts&"
import style0 from "./Lvl.vue?vue&type=style&index=0&id=887c479e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887c479e",
  null
  
)

export default component.exports